import React, { useEffect, useState } from 'react';

export const AddressForm = ({ onChange }) => {
  const [street, setStreet] = useState('');
  const [city, setCity] = useState('');
  const [postcode, setPostcode] = useState('');
  const style =
    'border-2 resize-none box-shadow-none border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 border-solid';
  useEffect(() => {
    if (street !== '' && city !== '' && postcode !== '') {
      const address = `${street}, ${city}, ${postcode}`;
      onChange(address);
    } else {
      onChange('');
    }
  }, [street, city, postcode]);

  return (
    <div className={'w-11/12 mt-2'}>
      <div className="mb-6 p-1">
        <label
          htmlFor="street"
          className="block text-gray-700 font-semibold mb-2"
        >
          Street Address
        </label>
        <input
          type="text"
          id="street"
          name="street"
          placeholder="e.g 8 Flint Street"
          value={street}
          onChange={(e) => setStreet(e.target.value)}
          className={style}
        />
      </div>
      <div className="mb-6 flex">
        <div className="w-6/12 p-1">
          <label
            htmlFor="city"
            className="block text-gray-700 font-semibold mb-2"
          >
            City
          </label>
          <input
            type="text"
            id="city"
            placeholder="e.g London"
            name="city"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            className={style}
          />
        </div>
        <div className="w-6/12 p-1">
          <label
            htmlFor="postcode"
            className="block text-gray-700 font-semibold mb-2"
          >
            Postcode
          </label>
          <input
            type="text"
            id="postcode"
            placeholder="e.g SW1 2AA"
            name="postcode"
            value={postcode}
            onChange={(e) => setPostcode(e.target.value)}
            className={style}
          />
        </div>
      </div>
    </div>
  );
};
